import { PaymentMethod } from '@ca/common'
import { Store } from '@ca/common/types'
import { usePrice } from 'hooks/useCurrency'
import { useStore } from 'hooks/useSession'
import { useMemo } from 'react'

export const getInvoiceFee = (
  store: Store | undefined,
  method: PaymentMethod | undefined
) => {
  if (method !== 'invoice') {
    return undefined
  }
  const hasOtherMethods = store?.prepay_method.find((m) => m.key !== 'invoice')
  const amount = hasOtherMethods && store?.type !== 'OWN' ? 7 : 0
  return amount
}

export const usePaymentMethodFee = (method?: PaymentMethod) => {
  const store = useStore()

  const amount = useMemo(() => getInvoiceFee(store, method), [store, method])

  const price = usePrice(amount ?? 0)

  return {
    fee: amount,
    feePrice: price,
  }
}
